import Image from '@app/components/Image'
import { IDevelopmentClient } from '@app/models/DevelopmentClient'
import { ImageSize } from '@app/models/enums'
import * as React from 'react'
import { Link } from 'react-router-dom'

export interface IDevelopmentClientResultItemProps {
  item: IDevelopmentClient
}

export class DevelopmentClientResultItem extends React.PureComponent<
  IDevelopmentClientResultItemProps
> {
  public render() {
    return (
      <Link
        to={`/development/client/${this.props.item.slug}`}
        className='result-item'
      >
        <div className='align-self-center'>
          <Image
            height={35}
            image={this.props.item.logo}
            size={ImageSize.h50w50}
            width={35}
          />
        </div>
        <div className='flex-grow-1 align-self-center font-weight-bold'>
          {this.props.item.name}
        </div>
      </Link>
    )
  }
}
